import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getPerformance, FirebasePerformance } from "firebase/performance";

import type { Analytics } from "firebase/analytics";

const getFirebaseInit = (): { analytics: Analytics | null, perf: FirebasePerformance | Record<string, never>; } => {
  if (import.meta.env.VUE_APP_ENV !== 'dev' && !window.location.origin.includes('localhost')) {

    const firebaseConfig = {
      apiKey: import.meta.env.VUE_APP_FIREBASE_API_KEY,
      authDomain: "ryd-pay-webview.firebaseapp.com",
      projectId: "ryd-pay-webview",
      storageBucket: "ryd-pay-webview.appspot.com",
      messagingSenderId: "718497430890",
      appId: import.meta.env.VUE_APP_FIREBASE_APP_ID,
      measurementId: import.meta.env.VUE_APP_FIREBASE_MEASUREMENT_ID
    };


    const app = initializeApp(firebaseConfig);
    const analytics = getAnalytics(app);

    const perf = getPerformance(app);
    return { analytics, perf };
  } else {
    // In development mode, we return empty objects to avoid errors
    return { analytics: null, perf: null };
  }
};
const { analytics, perf } = getFirebaseInit();

export { analytics, perf };